<template>
    <div class="basic_wrap">
      <div class="red_top_bg">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">{{$t('setpwd.modifyLoginPassword')}}</div>
      </div>
      <div class="wrap">
        <div class="title">
          <p>{{$t('setpwd.setNewLoginPassword')}}</p>
          <!-- 移除了切换验证方式的选项 -->
        </div>
  
        <!-- 输入旧密码 -->
        <div class="write_new_pwd">
          <div class="write_box">
            <input :type="oldPasswordInputType" v-model="oldPassword" :placeholder="$t('setpwd.originalloginpassword')">
            <div class="eye_bi" @click="toggleOldPasswordInput" :class="oldPasswordInputType=='text'?'eye':''"></div>
          </div>
        </div>
  
        <!-- 设置新密码和确认新密码 -->
        <div class="write_new_pwd">
          <div class="write_box">
            <input :type="npasswordInputType" v-model="npassword" :placeholder="$t('setpwd.newpassword')">
            <div class="eye_bi" @click="toggleNpasswordInput" :class="npasswordInputType=='text'?'eye':''"></div>
          </div>
          <div class="write_box">
            <input :type="rpasswordInputType" v-model="rpassword" :placeholder="$t('setpwd.confirmnewpassword')">
            <div class="eye_bi" @click="toggleRpasswordInput" :class="rpasswordInputType=='text'?'eye':''"></div>
          </div>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div class="basic_btn" :class="oldPassword && npassword && rpassword ? '' : 'no_touch'" @click="handleSubmit">
        {{ $t('setpwd.modify') }}
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import { Toast } from 'vant'; // 移除了 CountDown
  import Fetch from '../../utils/fetch';
  
  Vue.use(Toast);
  
  export default {
    name: "setpwd",
    data() {
      return {
        oldPassword: '', // 旧密码
        npassword: '', // 新密码
        rpassword: '', // 重复新密码
        npasswordInputType: 'password', // 新密码输入框类型
        rpasswordInputType: 'password', // 确认新密码输入框类型
        oldPasswordInputType: 'password', // 旧密码输入框类型
      };
    },
    created() {
      this.$parent.footer('user', false);
    },
    // 移除了 mounted 钩子，因为不再需要获取手机号信息或处理短信相关逻辑
    methods: {
      // 移除了 timeCall, sendcode, cutType, resetFields 等短信相关方法
  
      toggleNpasswordInput() {
        this.npasswordInputType = this.npasswordInputType === 'password' ? 'text' : 'password';
      },
      toggleRpasswordInput() {
        this.rpasswordInputType = this.rpasswordInputType === 'password' ? 'text' : 'password';
      },
      toggleOldPasswordInput() {
        this.oldPasswordInputType = this.oldPasswordInputType === 'password' ? 'text' : 'password';
      },
  
      handleSubmit() {
        // 验证旧密码是否为空
        if (!this.oldPassword) {
          this.$toast.fail(this.$t('setpwd.oldpasswordcannotbeempty') || '旧密码不能为空');
          return;
        }
        // 验证新密码是否为空
        if (!this.npassword) {
          this.$toast.fail(this.$t('setpwd.newpasswordcannotbeempty') || '新密码不能为空');
          return;
        }
        // 验证新密码和确认新密码是否一致
        if (this.npassword !== this.rpassword) {
          this.$toast.fail(this.$t('setpwd.inconsistent') || '新密码与确认密码不一致');
          return;
        }
  
        // 调用接口，通过旧密码修改密码
        Fetch('/index/forgetpwd', {
          password: this.oldPassword, // 提交旧密码
          npasswd: this.npassword, // 提交新密码
          rpassword: this.rpassword, // 提交新密码
        })
        .then(() => {
          this.$toast({
              background: '#07c160',
              message: this.$t('setpwd.modifiedsuccessfully')
          });
          this.$router.replace('/user')
        })
        .catch(err => {
          this.$toast.fail('修改失败，请重试');
        });
      }
    }
  };
  </script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .no_touch {
        pointer-events: none;
        opacity: 0.6; /* Indicate it's disabled */
    }

    .wrap {
        padding: 35px 20px 0 20px;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #000;
            font-weight: 400;
        }

        .cut {
            font-size: 12px;
            color: #3D96FF;
        }
    }

    .bd_tel {
        margin-top: 23px;
        color: #000;
        font-size: 14px;
        font-weight: 400;
    }

    .inp_box {
        display: flex;
        justify-content: space-between;
        height: 45px;
        margin-top: 9px;

        .inp {
            width: 195px; /* Adjust width as needed or use flex-grow */
            flex-grow: 1; /* Allow it to grow */
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            border-radius: 2px;
            background-color: #FFFFFF;

            input {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
                border: none; /* Remove default input border */
                outline: none; /* Remove default input outline */
            }
        }

        .getcode {
            flex-shrink: 0; /* Prevent shrinking */
            width: 120px; /* Specific width for the button */
            margin-left: 10px;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            color: #FFFFFF;
            height: 45px;
            background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
            border-radius: 8px;
            cursor: pointer; /* Indicate it's clickable */
            transition: opacity 0.3s ease; /* Smooth transition for opacity */
        }

        .reset_code {
            background: rgba(228, 228, 228, 1);
            color: rgba(0, 0, 0, 0.3);
            pointer-events: none; /* Disable clicks when counting down */
        }
    }

    .write_box {
        width: 100%;
        height: 45px;
        margin-top: 32px; /* This margin will apply to the first one in the group too, adjust below if needed */
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center; /* Vertically align items */
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input {
            flex-grow: 1; /* Allow input to take available space */
            height: 22px;
            line-height: 22px;
            font-size: 16px;
            border: none;
            outline: none;
        }
    }

    .eye_bi {
        flex-shrink: 0; /* Prevent eye icon from shrinking */
        width: 21px;
        height: 25px;
        margin-left: 10px; /* Space between input and eye */
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;
        cursor: pointer; /* Indicate it's clickable */

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
        width: 90%; /* Example width, adjust as per your global basic_btn style */
        max-width: 300px; /* Max width for larger screens */
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
        border-radius: 8px;
        color: #FFFFFF;
        font-size: 16px;
        cursor: pointer;
    }

    .write_new_pwd {
        /* Applies some top margin to the group of new/confirm password fields when they are first rendered. */
        /* If original password is present, this will come after it.
           If SMS code is present, this will come after it. */
        margin-top: 32px;

        .write_box:first-child {
            /* If this is the "new password" input box inside .write_new_pwd */
            margin-bottom: 18px; /* Space between new and confirm password */
            margin-top: 0px; /* Override the parent's margin-top for immediate children if they are the first `write_box` */
        }
        .write_box:last-child {
            /* If this is the "confirm new password" input box, ensure no extra top margin */
            margin-top: 0px;
        }
    }
</style>
